<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;" v-if="exibirDivValidar">
                    <div v-if="exibirDivValidarCodigo">
                        <h5 class="p-pt-4 p-d-flex p-jc-center">Redefinição de senha.</h5>
                        <p class="p-text-center">					
                            Informe o código para redefinir sua senha.
                        </p>
                        <div class="p-field">					
                            <span class="p-input-icon-left">
                                <i class="pi pi-user"/>                       
                                <InputText v-model.trim="codigo" type="text" placeholder="Código" aria-describedby="email-erro" />                            
                            </span>
                            <small id="email-erro" class="p-invalid" v-if="exibirErroEmail">Informe o código</small>  
                        </div>   
                        <div class="p-grid p-mt-3 p-mb-4">
                            <div class="p-col-12">
                                <Button label="Enviar" @click="enviar"/>
                            </div>
                        </div>	
                    </div>
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                    <Message severity="info" v-if="exibirSucesso">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import RevendedorService from '@/service/RevendedorService';

export default {
    revendedorService: null,
    data() {
        return {
            exibirDivValidar: false,
            exibirDivValidarCodigo: false,
            exibirSpin: false,
            exibirErroEmail: false,            
            mensagemErro: '',
            mensagemSucesso: '',
            exibirSucesso: false,
            exibirErro: false,
            codigo: '',
            token: '',
            email: '',
        }
    },    
    methods: {
        enviar() {
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;       
            this.exibirSucesso = false;
            this.mensagemSucesso = '';
            this.mensagemErro = '';   
            if(this.codigo == '') {
                this.exibirErroEmail = true;
            }            
            if(!this.exibirErroEmail && !this.exibirErroSenha) {         
                let dados = {
                    email: this.email,
                    token: this.token,
                    codigo: this.codigo
                }
                this.revendedorService.validarCodigoRedefinirSenha(dados)
                    .then(resp => {
                        this.exibirSpin = false;
                        let revendedor = resp.data;                       
                        sessionStorage.setItem('REVENDEDOR_REDEFINIR_SENHA', JSON.stringify(revendedor));
                        this.$router.push('/redefinir-senha');                   
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        validarToken() {
            this.exibirDivValidar = false;
            this.exibirDivValidarCodigo = false;
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;       
            this.exibirSucesso = false;
            this.mensagemSucesso = '';
            this.mensagemErro = ''; 
            if(typeof this.$route.query.tk === 'undefined' || typeof this.$route.query.em === 'undefined' ) {
                this.exibirSpin = false;
                this.mensagemErro = 'Essa solicitação não é válida';
                this.exibirErro = true;
                this.exibirDivValidar = true;
                setTimeout(() => {
                    this.$router.push('/login')
                }, 5000);
                return;
            }
            this.token = this.$route.query.tk;
            this.email = this.$route.query.em;
            let dados = {
                token: this.$route.query.tk,
                email: this.$route.query.em,
            }
            this.revendedorService.validarTokenRedefinirSenha(dados)
                .then(resp => {
                    this.exibirSpin = false;
                    this.exibirDivValidarCodigo = true;
                    this.exibirDivValidar = true;
                })
                .catch(erro => {       
                    this.exibirSpin = false;                 
                    this.exibirErro = true;
                    this.exibirDivValidar = true;
                    if(erro.response.status == 400) {
                        this.mensagemErro = erro.response.data.mensagem;
                    } else {
                        this.mensagemErro = erro.response.data.mensagem;
                    }
                });
        }     
    },
    created() {
        this.revendedorService = new RevendedorService();       
        this.validarToken();
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>